<template>
  <div class="form_item" :class="save_to+'_wrapper'" style="position: relative">
    <Label :required="required" :label="label" :name="name"/>
    <Multiselect
      :options="optionsList"
      label="name"
      :multiple="multiple"
      v-model="selected"
      :searchable="searchable"
      :closeOnSelect="closeOnSelect"
      :placeholder="placeholder"
      :limit="(limit>1)?limit:undefined"
      @input="handleValueChange"
      :showLabels="false"
      :options-limit="100000"
      :loading="isLoading"
      :clear-on-select="true"
      style="z-index: 1000"
      @search-change="asyncFind"
      :track-by="(multiple)?'value':undefined"
    >
      <template slot="noOptions">{{configuration.messageListEmpty || $t('multiselect_list_empty')}}</template>
      <template slot="singleLabel" slot-scope="props">
        <span class="option__desc">
          <span class="option__title">{{ props.option.name.split('\n').join(' - ') }}</span>
        </span>
      </template>

      <template slot="option" slot-scope="props">
        <div class="option__desc" v-if="props.option.name.split('\n').length > 0">
          <div class="option__small">{{ props.option.name.split('\n')[0] }}</div>
          <div class="option__title">{{ props.option.name.split('\n')[1] }}</div>
        </div>
        <div class="option__desc" v-else>
          <div class="option__title">{{ props.option.name }}</div>
        </div>
      </template>

    </Multiselect>
    <input type="text"
      :name="`${validationLabel || label}_hidden_required`"
      class="multiselect_hidden"
      v-model="selected" style="width: 1px; height: 1px;position: absolute; bottom:10px; left: 10px; z-index: 0;border:none;background-color:transparent;" :required="required"
    >
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span
      class="error"
      v-show="errors.has(validationLabel || label)"
      v-text="errors.first(validationLabel || label)"
    ></span>

  </div>
</template>

<script>
  // TODO replace vue-select by vue-multiselect
  import { validatorComponent } from './validatorComponentMixin';
  import i18n from './i18n';
  import Multiselect from 'vue-multiselect'
  import axios from 'axios'

  import 'vue-multiselect/dist/vue-multiselect.min.css';

  export default {
    name: 'selectMultiple',
    components: {
      Multiselect,
    },
    mixins: [validatorComponent, i18n.mixin],
    props: {
      options: {
        type: Array,
        required: true
      },
      value: {
        type: String,
      },
      save_to: String,
      configuration: {
        type: Object,
        default() {return {}},
      },
      placeholder: {
        type: String,
        default: '',
      },
      info: String,
      validationLabel: String,
      name: String,
      searchable: Boolean,
      ajax: Boolean,
      ajaxUrl: String,
      closeOnSelect: Boolean,
      multiple: Boolean,
      limit: Number,
    },
    data: function() {
      return {
        selected: undefined,
        isLoading: false,
        isDownloaded: false,
        ajaxOptions: [],
      }
    },
    computed: {
      optionsList() {
        if(this.ajax && this.ajaxUrl && this.ajaxUrl.indexOf('https://') > -1) {
          return this.ajaxOptions;
        } else {
          return this.options;
        }
      }
    },
    methods: {
      asyncFind (query) {
        if(this.isDownloaded || this.isLoading) {
          return;
        }
        if(this.ajax && this.ajaxUrl && this.ajaxUrl.indexOf('https://') > -1) {
          this.isLoading = true
          axios.get(this.ajaxUrl).then(response => {
            this.ajaxOptions = response.data;
            this.isLoading = false;
            this.isDownloaded = true;
          })
        }
      },
      handleValueChange (val) {
        console.log(val);
        // const value = val ? val[VALUE_COL_NAME] : null
        // this.selected = val
        if(this.multiple) {
          this.$emit('input', val.map((v)=>v.value).join(':'))
        } else {
          this.$emit('input', val.value)
        }
      },
    }
  }
</script>
<style>
.option__small {
  font-size: 0.8em;
}
</style>